/**
 * Player Spawn Behavior
 * 
 * Marks a location as the player spawn point. The position is extracted
 * during level loading and used to place the player character.
 * 
 * This is a marker-only behavior - no runtime state machine needed.
 */

import { EntityType } from '../../types/EntityTypes';
import type { EntityBehavior, NodeProcessContext, NodeProcessResult } from '../../core/BehaviorRegistry';
import type { BehaviorParameterSchema } from '../../core/BehaviorSchema';

const parameters: BehaviorParameterSchema = {
  // No parameters - pure position marker
};

export const playerSpawnBehavior: EntityBehavior = {
  id: 'spawn:player',
  displayName: 'Player Spawn',
  description: 'Marks the player spawn location. Position only, no configuration needed.',
  type: EntityType.STATIC_GEOMETRY, // Marker, no physics or state
  category: 'spawn',
  tags: ['spawn', 'player', 'marker'],
  parameters,
  
  // Process during level load: extract position
  onProcessNode: (ctx: NodeProcessContext): NodeProcessResult => {
    ctx.mesh.computeWorldMatrix(true);
    ctx.results.spawnPoint = ctx.mesh.getAbsolutePosition().clone();
    
    // Hide the spawn point marker
    ctx.mesh.isVisible = false;
    
    return { 
      handled: true, 
      skipPhysics: true, 
      hideNode: true 
    };
  },
  
  // No state machine - position is read during level load
  createMachine: undefined,
  
  onSpawn: undefined, // No runtime behavior
};
